import { Pipe, PipeTransform } from '@angular/core';
import { ServiceConnectionType } from '@jms/model';

@Pipe({
  name: 'serviceConnectionIcon',
  standalone: true
})
export class ServiceConnectionIconPipe implements PipeTransform {

  transform(type: ServiceConnectionType): string {

    switch (type) {

      case ServiceConnectionType.Xero: {
        return '/images/logo-xero-blue.svg';
      }

      case ServiceConnectionType.Myob: {
        return '/images/logo-myob.svg';
      }

      case ServiceConnectionType.QuickBooks: {
        return '/images/logo-quickbooks.svg';
      }

      case ServiceConnectionType.WorkBuddy: {
        return '/images/logo-workbuddy.png';
      }

      case ServiceConnectionType.Stripe: {
        return '/images/logo-stripe.svg';
      }

      case ServiceConnectionType.What3Words: {
        return '/images/logo-what3words.jpg';
      }

      case ServiceConnectionType.SMS: {
        return '/images/logo-sms.svg';
      }

      case ServiceConnectionType.OpenAI: {
        return '/images/ai/openai-logomark.svg';
      }

      case ServiceConnectionType.Anthropic: {
        return '/images/ai/anthropic-logomark.jpeg';
      }

      case ServiceConnectionType.PropertyMe: {
        return '/images/logo-propertyme.png';
      }

      case ServiceConnectionType.AddressValidation: {
        return '/images/logo-address-validation.svg';
      }
      case ServiceConnectionType.Jobpac: {
        return '/images/logo-jobpac.svg';
      }

      default: {
        return null;
      }

    }

  }

}
